module.exports = __webpack_public_path__ + "media/img/pages/profile/lgt ger 2-3df0d6461577997ebbb5514c0a5853d0.jpg";